

const _init = function (ui) {

    ui._on = false;

};

const _enable = function () {
    const ui = this;
    if (ui._enabled) return;
    ui.el.dataset.active = true;
    _addEventListeners(ui);
    ui._enabled = true;
};

const _disable = function () {
    const ui = this;
    if (!ui._enabled) return;
    ui.el.dataset.active = false;
    _addEventListeners(ui, false);
    ui._enabled = false;
};

const _destroy = function () {
    const ui = this;

    delete ui.el.data.uiController;

    delete ui.body.dataset.pagination;
    delete ui.el.dataset.on;

    ui.disable();
};

const _addEventListeners = function (ui, b) {

    if (b === false) {
        ui.el.removeEventListener('click', ui._onClick);
        ui.win.removeEventListener('scroll', ui._onScroll);
        return;
    }

    ui._onClick = () => {
        ui._on = !ui._on;
        _update(ui);
    };

    ui._onScroll = () => {
        ui._on = false;
        _update(ui);
    };

    ui.el.addEventListener('click', ui._onClick);
    ui.win.addEventListener('scroll', ui._onScroll);
};

const _close = function () {
    const ui = this;

    ui._on = false;
    _update(ui);
};

const _isOn = function () {
    return this._on;
};

const _update = ui => {
    ui.body.dataset.pagination = ui._on;
    ui.el.dataset.on = ui._on;
};

module.exports = el => {

    if (el.data && el.data.uiController) return el.data.uiController;

    const ui = {};
    ui.el = el;
    ui.win = window;
    ui.body = document.body;

    ui.el.data = ui.el.data || {};
    ui.el.data.uiController = ui;

    ui.type = 'sandwich';
    ui.close = _close.bind(ui);
    ui.enable = _enable.bind(ui);
    ui.disable = _disable.bind(ui);
    ui.destroy = _destroy.bind(ui);
    ui.isOn = _isOn.bind(ui);

    _init(ui);

    return ui;
}


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/ui/SandwichUI.js